import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  OPEN_RESPONSE_MODAL,
  SET_KEYWORD_SEARCH,
  SALE_PRODUCT_LIST_REQUEST,
  SALE_PRODUCT_LIST_SUCCESS,
  SALE_PRODUCT_LIST_FAILURE,
  SALE_PRODUCT_GET_REQUEST,
  SALE_PRODUCT_GET_SUCCESS,
  SALE_PRODUCT_GET_FAILURE,
  SALE_PRODUCT_GET_RESET,
  SALE_PRODUCT_CREATE_REQUEST,
  SALE_PRODUCT_CREATE_SUCCESS,
  SALE_PRODUCT_CREATE_FAILURE,
  SALE_PRODUCT_CREATE_RESET,
  SALE_PRODUCT_EDIT_REQUEST,
  SALE_PRODUCT_EDIT_SUCCESS,
  SALE_PRODUCT_EDIT_FAILURE,
  SALE_PRODUCT_EDIT_RESET,
  SALE_PRODUCT_DELETE_REQUEST,
  SALE_PRODUCT_DELETE_SUCCESS,
  SALE_PRODUCT_DELETE_FAILURE,
  SALE_PRODUCT_DELETE_RESET,
  SALE_PRODUCT_EXPORT_REQUEST,
  SALE_PRODUCT_EXPORT_SUCCESS,
  SALE_PRODUCT_EXPORT_FAILURE,
  SALE_PRODUCT_EXPORT_RESET,
  SHOW_MANUAL_SALE_PRODUCT,
  CLOSE_MANUAL_SALE_PRODUCT,
} from './types'

export function getSaleProduct(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/products`,
      method: 'GET',
      types: [
        SALE_PRODUCT_LIST_REQUEST,
        SALE_PRODUCT_LIST_SUCCESS,
        SALE_PRODUCT_LIST_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function getSaleProductById(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/products/${id}`,
      method: 'GET',
      types: [
        SALE_PRODUCT_GET_REQUEST,
        SALE_PRODUCT_GET_SUCCESS,
        SALE_PRODUCT_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function createSaleProduct(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/products`,
      method: 'POST',
      types: [
        SALE_PRODUCT_CREATE_REQUEST,
        SALE_PRODUCT_CREATE_SUCCESS,
        SALE_PRODUCT_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function editSaleProduct(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/products/${id}`,
      method: 'PUT',
      types: [
        SALE_PRODUCT_EDIT_REQUEST,
        SALE_PRODUCT_EDIT_SUCCESS,
        SALE_PRODUCT_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function deleteSaleProduct(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/products/${id}`,
      method: 'DELETE',
      types: [
        SALE_PRODUCT_DELETE_REQUEST,
        SALE_PRODUCT_DELETE_SUCCESS,
        SALE_PRODUCT_DELETE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function exportSaleProduct(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/products/exports`,
      method: 'GET',
      types: [
        SALE_PRODUCT_EXPORT_REQUEST,
        SALE_PRODUCT_EXPORT_SUCCESS,
        SALE_PRODUCT_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function resetCreatedSaleProduct() {
  return {
    type: SALE_PRODUCT_CREATE_RESET,
  }
}

export function resetGetSaleProduct() {
  return {
    type: SALE_PRODUCT_GET_RESET,
  }
}

export function resetUpdatedSaleProduct() {
  return {
    type: SALE_PRODUCT_EDIT_RESET,
  }
}

export function resetDeletedSaleProduct() {
  return {
    type: SALE_PRODUCT_DELETE_RESET,
  }
}

export function resetExportedSaleProduct() {
  return {
    type: SALE_PRODUCT_EXPORT_RESET,
  }
}

export function openResponseModal(payload) {
  return {
    type: OPEN_RESPONSE_MODAL,
    payload,
  }
}

export function setKeywordSearch(payload) {
  return {
    type: SET_KEYWORD_SEARCH,
    payload,
  }
}

export function openManual() {
  return {
    type: SHOW_MANUAL_SALE_PRODUCT,
  }
}

export function closeManual() {
  return {
    type: CLOSE_MANUAL_SALE_PRODUCT,
  }
}



// WEBPACK FOOTER //
// ./src/actions/sale-product/sale-product.js